import { Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AwsAuthService } from '@nx/auth';
import { lmwBaseRoutes } from './route-locales/lmw-base-routes';
import { lmwAuthLazyLoadedState } from '../../auth-process/common/routing/route-locales/app-routes';
import { signInLazyLoaded } from '../../auth-process/sign-in/routing/route-locales/sign-in-routes';
import { signInUsernameState } from '../../auth-process/sign-in/routing/sign-in.states';
import { signInPreviousRouteContext } from '../../auth-process/sign-in/constants/sign-in.constants';
import { map } from 'rxjs/operators';
import { createPreviousRoutes } from '@nx/mono-common';

@Injectable({
  providedIn: 'root',
})

export class MyLearningRouteGuard  {

  constructor(private awsAuthService: AwsAuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return from(this.awsAuthService.isUserLoggedIn()).pipe(
      map(isLoggedIn => {
        if(!isLoggedIn) {
          const previousRoutes = createPreviousRoutes({ [signInPreviousRouteContext]: `/${lmwBaseRoutes.myLearningHomeStatePath}` });
          this.router.navigate([`/${lmwAuthLazyLoadedState.path}/${signInLazyLoaded.path}/${signInUsernameState.path}`], { state: { ...previousRoutes } });
          return false;
        }
        else {
          return true;
        }
      })
    )
  }
}
